import * as React from 'react';
import Spinner from '@mulesoft/anypoint-components/lib/Spinner';
import { connect } from 'react-redux';
import { AppState, Dispatch } from '../../types';
import { AccessDeniedSvg } from './AccessDeniedSvg';

import { 
  selectors as lifcycleSelectors, 
  actions as lifecycleActions 
} from '../../lifecycle/lifecycle';

type ValueProps = {
  permissionsChecked: boolean,
  hasMonitoringCenter: boolean,
  hasApiMonitoring: boolean,
  hasViewRole: boolean
}

type EventProps = {
  checkPermissions: () => void
}

export type Props = ValueProps & EventProps;

export class PermissionsChecker extends React.Component<Props, {}> {
  componentDidMount() {
    // Check permissions when component mounts
    this.props.checkPermissions();
  }

  render() {
    const { permissionsChecked, hasViewRole, hasMonitoringCenter, hasApiMonitoring, children } = this.props;
    // Show loading spinner while permissions are being checked
    if (!permissionsChecked) {
      return (
        <div className="app-loading">
          <Spinner size="m" />
        </div>
      );
    }

    // If user doesn't have any required entitlements
    if (!hasMonitoringCenter && !hasApiMonitoring) {
      return (
        <div className="app-error">
          <p>You don't have access to Anypoint Monitoring.</p>
          <p>
            Your organization needs an Anypoint Monitoring or API Functional Monitoring subscription.
          </p>
          <AccessDeniedSvg />
        </div>
      );
    }

    // If user doesn't have view role
    if (!hasViewRole) {
      return (
        <div className="app-error">
          <p>You don't have permission to access Anypoint Monitoring.</p>
          <p>
            Ask your administrator to grant you the Monitoring User or Monitoring Viewer permission.
          </p>
          <AccessDeniedSvg />
        </div>
      );
    }

    // User has permissions, render children
    return children;
  }
}

const mapState = (rootState: AppState): ValueProps => ({
  permissionsChecked: lifcycleSelectors.getPermissionsChecked(rootState),
  hasMonitoringCenter: lifcycleSelectors.getHasMonitoringCenter(rootState),
  hasApiMonitoring: lifcycleSelectors.getHasApiMonitoring(rootState),
  hasViewRole: lifcycleSelectors.getHasViewRole(rootState)
});

const mapDispatchToProps = (dispatch: Dispatch): EventProps => ({
  checkPermissions: () => dispatch(lifecycleActions.checkPermissions())
});

export default connect(mapState, mapDispatchToProps)(PermissionsChecker);
